import { ReactElement } from 'react'
import CloseIcon from '@mui/icons-material/Close'
import { Box, IconButton, Stack, Tooltip, Typography } from '@mui/material'
import { AiInstruction } from 'src/state/stores/app'
import { buildInstructionPreview } from './utils'

interface Props {
  instruction: AiInstruction
  onRemove: (instructionId: string) => void
}

const InstructionRow = ({ instruction, onRemove }: Props): ReactElement => {
  const elementLabels = instruction.elements.map(element => element.label).join(', ')

  return (
    <Stack
      direction="row"
      alignItems="center"
      spacing={1}
      data-cy="ai-instruction-row"
      sx={{ minWidth: 0 }}
    >
      <Box sx={{ minWidth: 0, flex: 1 }}>
        {elementLabels && (
          <Typography variant="caption" color="text.secondary" noWrap component="div">
            {elementLabels}
          </Typography>
        )}
        <Typography variant="body2" noWrap title={instruction.text}>
          {buildInstructionPreview(instruction.text)}
        </Typography>
      </Box>
      <Tooltip title="Instruktion entfernen">
        <IconButton
          size="small"
          onClick={() => onRemove(instruction.id)}
          data-cy="ai-instruction-remove"
        >
          <CloseIcon fontSize="inherit" />
        </IconButton>
      </Tooltip>
    </Stack>
  )
}

export default InstructionRow
